import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { getPLSyncInfo, storeSelectedPLId } from '../ProjectLocations.reducer';
import { storeSelectedProjectId } from '../../Projects/Projects.reducer';
import { useSelector } from 'react-redux';

export const useStorePlInitialData = () => {
    const { storeUrls, token } = useSelector((state) => state.generalReducer);
    const dispatch = useDispatch();

    const { projectId, locationId } = useParams();

    useEffect(() => {
        if (projectId) {
            dispatch(storeSelectedProjectId(Number(projectId)));
        }
    }, [dispatch, projectId]);

    useEffect(() => {
        if (locationId && storeUrls.PROJECT_LOCATIONS_URL?.url && token) {
            dispatch(storeSelectedPLId(Number(locationId)));
            dispatch(getPLSyncInfo());
        }
    }, [dispatch, locationId, storeUrls.PROJECT_LOCATIONS_URL?.url, token]);

    return { projectId, locationId };
};
